/**
 * * @module pages/get-involved.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _, { select } from "underscore";
import BootstrapSelect from "bootstrap-select";
import moment from "moment";
// import "isomorphic-fetch"

const Basket = Backbone.View.extend({
  el: $(document),

  // basket: {},

  groupedTickets: [],
  allFunds: [],
  basketDonations: [],
  memberships: [],
  emptyBasket: false,

  events: {
    'change .page-template-page-custom-basket input[name="spektrix_membership"]':
      "manageMembership",
    "click .page-template-page-custom-basket .promo-form .button":
      "submitPromoCode",
    "click .delete-ticket": "deleteTicket",
    "click .delete-membership": "deleteMembership",
    "click .delete-donation": "deleteDonation",
    "click .radio-button-container": "membershipRadio",
  },

  getBasket: {
    credentials: "include",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
    method: "GET",
  },

  initialize: function () {
    this.render();

    $("#donation-amount-select").hide();
  },

  loadBasket: function () {
    const _this = this;

    //  {
    //     instance: "9802AVVSDKQBDSCDRGQKTKDKNHLPKMDCG", //instanceID below event data
    //     type: "801ARDQDDMGGJKKRTNTJBMCCMMBCPQKCR", // ticketType ID
    //     seatingPlan: "4401APLLPBSHLDJVTLGBDQTQBHJDJSHCM", //planID
    //   },

    // // post to basket
    // const items = [
    //   {
    //     instance: "9802AVVSDKQBDSCDRGQKTKDKNHLPKMDCG",
    //     type: "801ARDQDDMGGJKKRTNTJBMCCMMBCPQKCR",
    //     seat: "45516",
    //   },
    //   {
    //     instance: "9802AVVSDKQBDSCDRGQKTKDKNHLPKMDCG",
    //     type: "801ARDQDDMGGJKKRTNTJBMCCMMBCPQKCR",
    //     seat: "45517",
    //   },
    // ];

    // const addToBasket = {
    //   credentials: "include",
    //   headers: {
    //     "Content-type": "application/json; charset=UTF-8",
    //   },
    //   method: "POST",
    //   body: JSON.stringify(items),
    // };

    //fetch basket
    fetch(ajax_client.spektrix_api_url + "/basket?$expand=1", _this.getBasket)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        console.log("fetch basket");
        console.log(data);

        _this.basket = data;
        // fetch(
        //   ajax_client.spektrix_api_url + "/basket?$expand=1",
        //   _this.getBasket
        // )
        //   .then(function (response) {
        //     return response.json();
        //   })
        //   .then(function (data) {
        //     console.log("expanded basket");
        //     console.log(data);
        //   });

        if (
          data.tickets.length == 0 &&
          data.donations.length == 0 &&
          data.giftVouchers.length == 0 &&
          data.membershipSubscriptions.length == 0 &&
          data.merchandiseItems.length == 0
        ) {
          let $wrapper = $(".basket-wrapper");
          $("table", $wrapper).remove();
          $wrapper.append("<p>The basket is empty</p>");
          $(".checkout-button, .promo-code-wrapper").remove();
          _this.emptyBasket = true;
        } else {
          _this.addTicketsToBasketOnPage(data);
        }

        _this.groupedTickets.basketId = data.id;
      });
  },

  addTicketsToBasketOnPage: function (data) {
    const _this = this;
    console.log("tickets");
    console.log(data.tickets);
    const tickets = data.tickets;
    let promises = [];

    if (tickets) {
      for (let i = 0; i < tickets.length; i++) {
        //get the instance ID
        let firstInstanceID = tickets[i].instance.id;

        //if it's not in our array
        if (
          _this.groupedTickets[firstInstanceID] == undefined ||
          !firstInstanceID in _this.groupedTickets
        ) {
          _this.groupedTickets[firstInstanceID] = {};
          _this.groupedTickets[firstInstanceID].tickets = [];
          _this.groupedTickets[firstInstanceID].ticketsRunningTotal = 0;
        }

        //we add the ticket to tickets
        _this.groupedTickets[firstInstanceID].tickets.push({
          planName: tickets[i].planName
            ? (tickets[i].planName == "Your Seating Plan Name Goes Here"
                ? ""
                : tickets[i].planName) + " "
            : "",
          seatName: tickets[i].seatName,
          total: tickets[i].total,
          eventId: tickets[i].event.id,
          ticketId: tickets[i].id,
        });

        _this.groupedTickets[firstInstanceID].eventId = tickets[i].event.id;
        _this.groupedTickets[firstInstanceID].ticketsRunningTotal +=
          tickets[i].total;
      }

      // we have grouped tickets, let's add event data
      for (let secondInstanceID in _this.groupedTickets) {
        promises.push(
          fetch(
            ajax_client.spektrix_api_url +
              "/events/" +
              _this.groupedTickets[secondInstanceID].eventId,
            _this.getBasket
          )
            .then(function (response) {
              return response.json();
            })
            .then(function (data) {
              if (data.name) {
                _this.groupedTickets[secondInstanceID].eventName = data.name;
              }
              return;
            })
        );

        promises.push(
          fetch(
            ajax_client.spektrix_api_url + "/instances/" + secondInstanceID,
            _this.getBasket
          )
            .then(function (response) {
              return response.json();
            })
            .then(function (data) {
              if (data.start) {
                let formattedDate = _this.formatDate(data.start);
                _this.groupedTickets[secondInstanceID].formattedDate =
                  formattedDate;
              }
              return;
            })
        );
      }
    }

    Promise.all(promises).then(() => {
      // console.log('done');
      // console.log("finished gathering data");
      // console.log(_this.groupedTickets);

      for (let thirdInstanceID in _this.groupedTickets) {
        if (_this.groupedTickets[thirdInstanceID].tickets) {
          const numOfTickets =
            _this.groupedTickets[thirdInstanceID].tickets.length;
          const instanceNoLetters = thirdInstanceID.replace(/[^0-9]/g, "");

          $(".basket-wrapper tbody").append(`<tr class="item-row">
              <td class="item-cell padding-bottom" id="${thirdInstanceID}">
                  <span class="ticket-data ticket-name">${
                    _this.groupedTickets[thirdInstanceID].eventName
                  }</span>
                  <span class="ticket-data ticket-date">${
                    _this.groupedTickets[thirdInstanceID].formattedDate
                  }</span>
                  <div class="seats"></div>
              </td>
              <td class="padding-top"><span class="ticket-data">${numOfTickets}</span></td>
              <td class="last-cell padding-top"><span class="ticket-data total" data-total="${
                _this.groupedTickets[thirdInstanceID].ticketsRunningTotal
              }">&pound;${_this.groupedTickets[
            thirdInstanceID
          ].ticketsRunningTotal.toFixed(2)}</span></td>
          </tr>`);

          for (
            let i = 0;
            i < _this.groupedTickets[thirdInstanceID].tickets.length;
            i++
          ) {
            $("#" + thirdInstanceID + " .seats").append(
              `<div class="seat-container"><span class="ticket-data ticket-seat">${
                _this.groupedTickets[thirdInstanceID].tickets[i].planName
              }  ${
                _this.groupedTickets[thirdInstanceID].tickets[i].seatName
                  ? "Seat " +
                    _this.groupedTickets[thirdInstanceID].tickets[i].seatName
                  : ""
              }</span>
                <nav class="tickets-management">
                  <ul>
                    <li><a href="/edit-tickets/${instanceNoLetters}">Edit</a></li>
                    <li><a href="#" class="delete-ticket" data-ticket="${
                      _this.groupedTickets[thirdInstanceID].tickets[i].ticketId
                    }">Delete</a></li>
                  </ul>
                </nav></div>`
            );
          }
        }
      }

      // <li><a href="#" class="delete-ticket" data-ticket="${
      //   _this.groupedTickets[thirdInstanceID].tickets[i].ticketId
      // }">Delete</a></li>

      if (data.offers.length > 0) {
        let output = `<p>Your tickets have been discounted as part of the offers: <ul>`;
        for (var i = 0; i <= data.offers.length; i++) {
          if (data.offers[i] != undefined) {
            output += `<li>${data.offers[i].name}</li>`;
          }
        }
        output += `</ul></p>`;

        $(".membership-block .discount").addClass("d-none");
        $(".promo-code-wrapper").prepend(output);
      }

      if (data.giftVouchers.length) {
        data.giftVouchers.forEach((voucher) => {
          $(".basket-wrapper tbody").append(`<tr class="item-row">
              <td class="item-cell padding-bottom" id="voucher">
                  <span class="ticket-data ticket-name">Gift voucher</span>
                  <span class="ticket-data ticket-date">To: ${
                    voucher.toName
                  }  (to be sent on ${moment(voucher.sendDate).format(
            "DD/MM/YYYY"
          )})</span>
                  <div class="seats"></div>
              </td>
              <td class="padding-top"><span class="ticket-data">1</span></td>
              <td class="last-cell padding-top"><span class="ticket-data total" data-total="${
                voucher.amount
              }">&pound;${voucher.amount.toFixed(2)}</span></td>
          </tr>`);
        });
      }

      _this.populateBasketTotals(data);
      _this.checkMembershipAndDonationsAreInBsket(data);
      _this.grabPlayHouseMembershipSaving();
      // _this.checkDonationInBasket(data);
    });
  },

  formatDate(dateStr) {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const date = new Date(dateStr);
    // const month = '' + (date.getMonth() + 1);
    const monthIndex = date.getMonth();
    const monthName = months[monthIndex];
    const day = "" + date.getDate();
    const dayIndex = date.getDay();
    const dayName = days[dayIndex];
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();

    const formattedDate = `${dayName} ${day} ${monthName} ${year} ${hours}:${minutes}`;

    return formattedDate;
  },

  populateBasketTotals: function (data) {
    const $totalRow = $(".last-cell .final-total");
    $totalRow.html("&pound;" + data.total.toFixed(2));
    $totalRow.data("total", data.total);

    $(".last-cell .booking-fee").html(
      "&pound;" + data.transactionCommission.amount.toFixed(2)
    );

    //check for promo
    let discount = data.promoCode ? data.totalDiscount : 0;

    if (discount > 0) {
      $("#promo")
        .attr("placeholder", data.promoCode)
        .addClass("disabled-input")
        .attr("disabled", "disabled");

      $(".promo-form .button").hide();
      $(".promo-form .buttons").append(
        '<span class="promo-applied">Promo code added</span>'
      );

      $("tfoot .promo-label")
        .removeClass("hidden")
        .html("Promo code " + data.promoCode);

      $("tfoot .promo-data")
        .removeClass("hidden")
        .html("-&pound; " + discount.toFixed(2));
    }
  },

  checkMembershipAndDonationsAreInBsket: function (basketdata) {
    let _this = this;
    let memberships,
      funds,
      donation_from_basket,
      fake_donation = [];
    let membershipText = undefined;

    const fund_ids = _.pluck(basketdata["donations"], "fund");
    const membership_ids = _.pluck(
      basketdata["membershipSubscriptions"],
      "membership"
    );
    const $textToSwap = $("#description2");

    const requestParams = {
      credentials: "include",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
      method: "GET",
    };

    try {
      fetch(ajax_client.spektrix_api_url + "/memberships", requestParams)
        .then(function (data) {
          return data.json();
        })
        .then(function (data) {
          memberships = data;
          fetch(ajax_client.spektrix_api_url + "/funds", requestParams)
            .then(function (data) {
              return data.json();
            })
            .then(function (data) {
              funds = data;

              for (const membership of membership_ids) {
                let membership_in_basket = _.where(memberships, {
                  id: membership.id,
                });
                // console.log('membership_in_basket', membership_in_basket);

                const membershipArray = _.pluck(
                  basketdata["membershipSubscriptions"],
                  "id"
                );
                const id = membershipArray[0];
                const fund = _.pluck(
                  basketdata["membershipSubscriptions"],
                  "membership"
                );
                const fundId = fund[0].id;
                const name = membership_in_basket[0].name;
                const priceObj = _.pluck(
                  basketdata["membershipSubscriptions"],
                  "price"
                );
                let price = priceObj[0];

                $(".membership-block .description-texts div").each(function () {
                  if ($(this).data("fund") == fundId) {
                    membershipText = $(this).html();
                  }
                });

                for (const fund of fund_ids) {
                  let fund_in_basket = _.where(funds, { id: fund.id });
                  // console.log('fund', fund);
                  // console.log('fund_in_basket', fund_in_basket);

                  donation_from_basket = _.filter(
                    basketdata["donations"],
                    function (donationData) {
                      if (donationData.fund.id === fund_in_basket[0].id) {
                        return donationData;
                      }
                    }
                  );

                  // console.log('fund_in_basket[0].name', fund_in_basket[0].name);
                  // console.log('name', name);

                  if (fund_in_basket[0].name == name) {
                    // console.log('finding fake donation');
                    price += donation_from_basket[0].amount;
                    fake_donation = donation_from_basket[0];
                  }
                  // console.log('fake_donation',fake_donation);
                }

                $(".basket-wrapper tbody").append(`<tr class="item-row">
                <td class="item-cell padding-bottom" id="${fundId}">
                    <span class="ticket-data ticket-name">${name}</span>
                    <nav class="tickets-management">
                    <ul>
                      <li><a href="#" class="delete-membership" data-membership="${id}">Delete</a></li>
                    </ul>
                  </nav>
                </td>
                <td class="padding-top"><span class="ticket-data">1</span></td>
                <td class="last-cell padding-top"><span class="ticket-data total">&pound;${price.toFixed(
                  2
                )}</span></td>
              </tr>`);
                if (membershipText) {
                  $(".membership-block .memberships").hide();
                  $(".membership-block .footer-buttons").hide();
                  $(".membership-block #description1").html(membershipText);
                  $(".membership-block .description").remove();
                }
              }

              for (const donation in basketdata["donations"]) {
                let donationFundId = basketdata["donations"][donation].fund.id;
                let donationFundAmount =
                  basketdata["donations"][donation].amount;
                let donationId = basketdata["donations"][donation].id;

                if (
                  fake_donation.length === 0 ||
                  fake_donation.fund.id !== donationFundId
                ) {
                  if (donationFundId) {
                    $textToSwap.html(
                      "You’ve added a £" +
                        donationFundAmount +
                        " donation to your basket. Thank you for supporting Nottingham Playhouse."
                    );

                    $(".donations-block .footer-buttons").hide();
                  }

                  fetch(ajax_client.spektrix_api_url + "/funds", requestParams)
                    .then(function (data) {
                      return data.json();
                    })
                    .then(function (data) {
                      let fundData = data.filter(function (value, index) {
                        return donationFundId == value.id;
                      });

                      $(".basket-wrapper tbody").append(`<tr class="item-row">
                      <td class="item-cell padding-bottom">
                          <span class="ticket-data ticket-name">Donation - ${
                            fundData[0].name
                          }</span>
                          <nav class="tickets-management">
                          <ul>
                            <li><a href="#" class="delete-donation" data-donation="${donationId}">Delete</a></li>
                          </ul>
                        </nav>
                      </td>
                      <td class="padding-top"><span class="ticket-data">1</span></td>
                      <td class="last-cell padding-top"><span class="ticket-data total">&pound;${donationFundAmount.toFixed(
                        2
                      )}</span></td>
                  </tr>`);
                    });
                }
              }

              if ($(window).width() < 769) {
                _this.moveSidebar();
              }
            });
        });
    } catch (e) {
      console.log(e);
    }
  },

  deleteMembership: function (e) {
    e.preventDefault();
    const _this = this;
    const membershipID = $(e.target).data("membership");

    if (membershipID == "") {
      return;
    } else {
      const deleteData = {
        credentials: "include",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        method: "DELETE",
        // body: JSON.stringify(dataToPass),
      };

      fetch(
        ajax_client.spektrix_api_url +
          "/basket/membership-subscriptions/" +
          membershipID,
        deleteData
      )
        .then(function (response) {
          return response.text();
        })
        .then(function (data) {
          // console.log(data);
          window.location.reload(false);
        });
    }
  },

  deleteDonation: function (e) {
    e.preventDefault();
    const _this = this;
    const donationID = $(e.target).data("donation");

    if (donationID == "") {
      return;
    } else {
      const deleteData = {
        credentials: "include",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        method: "DELETE",
        // body: JSON.stringify(dataToPass),
      };

      fetch(
        ajax_client.spektrix_api_url + "/basket/donations/" + donationID,
        deleteData
      )
        .then(function (response) {
          return response.text();
        })
        .then(function (data) {
          // console.log(data);
          window.location.reload(false);
        });
    }
  },

  submitPromoCode: function (e) {
    e.preventDefault();
    const promoCode = $("#promo").val();

    if (promoCode == "") {
      return;
    } else {
      const dataToPass = {
        promoCode: promoCode,
      };

      const patchData = {
        credentials: "include",
        headers: {
          "Content-type": "application/json",
        },
        method: "PATCH",
        body: JSON.stringify(dataToPass),
      };

      fetch(ajax_client.spektrix_api_url + "/basket", patchData)
        .then(function (response) {
          // console.log(response);
          return response.json();
        })
        .then(function (data) {
          // console.log(data);
          window.location.reload(false);
        })
        .catch((error) => console.log(error.message));
    }
  },

  deleteTicket: function (e) {
    e.preventDefault();
    const _this = this;
    const basketId = _this.groupedTickets.basketId;
    const ticketID = $(e.target).data("ticket");

    if (basketId == "" && ticketID == "") {
      return;
    } else {
      const dataToPass = {
        // id: basketId,
        ticketIds: [ticketID],
      };

      const deleteData = {
        credentials: "include",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        method: "DELETE",
        // body: JSON.stringify(dataToPass),
      };

      // https://system.spektrix.com/nottinghamplayhouse_staging/api/v3/Help/Api/DELETE-v3-basket-tickets?mode=ShowAll
      // DELETE https://system.spektrix.com/{{clientname}}/api/v3/basket/tickets?ticketids=59946ACRDDKRBTQBNKRTGHNCSTHVRVLMT,59947ABJTNJKVDCSGBNJLGPRMGRSPRDHJ
      fetch(
        // ajax_client.spektrix_api_url + "/baskets/"+basketId+"/tickets/"+ticketID,
        ajax_client.spektrix_api_url + "/basket/tickets?ticketIds=" + ticketID,
        deleteData
      )
        .then(function (response) {
          return response.text();
        })
        .then(function (data) {
          console.log(data);
          window.location.reload(false);
        });
    }
  },

  manageCollapsibleSection: function () {
    const $collapsibleArea = $(".description-wrapper");
    $collapsibleArea.addClass("collapse");

    $(".page-template-page-custom-basket .description-wrapper").on(
      "show.bs.collapse",
      function (e) {
        $(".accordion-item-title-button-basket").addClass("open");
      }
    );

    $(".page-template-page-custom-basket .description-wrapper").on(
      "hide.bs.collapse",
      function (e) {
        $(".accordion-item-title-button-basket").removeClass("open");
      }
    );
  },

  grabPlayHouseMembershipSaving: function () {
    const _this = this;

    // This is the Playhouse Pass membership.
    const playhousePassmembershipId = "15ALVMQHNVHKNVGHKKKPDSCQQQKBTCGJB";
    const payload = {
      credentials: "include",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
      method: "GET",
    };

    const membershipsRes = fetch(
      ajax_client.spektrix_api_url + "/memberships",
      payload
    ).then(function (response) {
        return response.json();
    }).then(function (data) {
        const exists = data?.some(obj => obj.id === playhousePassmembershipId);

        if (exists) {
          // check saving amount
          fetch(
            ajax_client.spektrix_api_url + "/basket/potentialdiscount?membershipId=" + playhousePassmembershipId,
            payload
          )
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            console.log("saving", data);

            if (data.totalDiscount && !_this.basket.promoCode) {
              $(".aside-block.membership-block p.description").before('<p class="discount">Save &pound;' + data.totalDiscount + ' with a Playhouse Pass today!</p>');
            }

            return;
          })
        } else {
          return;
        }
    });

  },

  moveSidebar: function () {
    const _this = this;
    const $whereToPlaceSidebar = $(".basket-wrapper table tbody");
    const $blocks = $(".aside-block");

    console.log("moveSidebar", _this.emptyBasket);

    if (_this.emptyBasket === true) {
      $(".basket-wrapper").after(
        '<tr><td colspan="3" id="col-for-blocks"></td></tr>'
      );
    } else {
      $(".basket-wrapper table tbody tr:last-child").after(
        '<tr><td colspan="3" id="col-for-blocks"></td></tr>'
      );
    }

    $("#col-for-blocks").append($blocks);
    $(".article-sidebar").remove();
  },

  manageMembership: function (e) {
    const $spektrixDiv = $("spektrix-memberships");
    const fundID = $(e.target).val();

    $spektrixDiv.attr("membership-id", fundID);
  },

  setUpDonationSelect: function () {
    $("#donation-amount-select").on("changed.bs.select", function (e) {
      const $submitButton = $("#donation-amount");
      var value = $(e.target).val();

      $submitButton.val(value);
      $submitButton.attr("data-donate-amount", value);
      $('[name="donation-amount"]').val(value);

      document
        .getElementById("donation-amount-select")
        .dispatchEvent(new Event("input", { bubbles: true }));
      document
        .getElementById("donation-amount-select")
        .dispatchEvent(new Event("change", { bubbles: true }));
    });
  },

  membershipRadio: function (e) {
    const $radioContainer = $(e.target).closest(".membership");
    const $buttonToShow = $(".footer-buttons", $radioContainer);
    $(".memberships .membership .footer-buttons").hide();
    $buttonToShow.show();
  },

  render: function () {
    if ($(window).width() < 769) {
      this.manageCollapsibleSection();
    }
    this.loadBasket();
    this.setUpDonationSelect();
    // console.log(ajax_client);
  },
});

export default Basket;
